<template>
	<div>
		<Row style="padding-top: 20px;">
			<Form :label-width="80">
				<FormItem label="申请时间">
					<RadioGroup v-model="timePeriod" @on-change="mySearch">
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="分发时间">
					<RadioGroup v-model="postTimePeriod" @on-change="mySearch">
						<Radio label="" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="postTimePeriodDate == '7' " :value="postTimePeriodDate" @on-change="postTimePeriodDateChange"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="条件">
					<Select filterable v-model="cid" clearable style="width:200px" placeholder="渠道id">
						<Option v-for="item in cidList" :value="item.id" :key="item.id">{{ item.username }}</Option>
					</Select>
					<Select filterable v-model="clientId" clearable style="width:200px;margin-left: 10px;" placeholder="下游客户">
						<Option v-for="item in clientList" :value="item.id" :key="item.id">{{ item.username }}</Option>
					</Select>
					<Select filterable v-model="src" clearable style="width:200px;margin-left: 10px;" placeholder="媒体代码">
						<Option v-for="item in srcList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
					<Select filterable v-model="distribute_status" clearable style="width:200px;margin-left: 10px;" placeholder="分发状态">
						<Option value=1>是</Option>
						<Option value=0>否</Option>
					</Select>
				</FormItem>
				<FormItem label="条件">
					<Select filterable v-model="city" clearable style="width:200px" placeholder="城市">
						<Option v-for="item in cityList" :value="item.city" :key="item.city">{{ item.city }}</Option>
					</Select>

					<Input v-model="name" style="width:200px;margin-left: 10px;"  placeholder="请输入姓名/电话号码"></Input>
					<Button style="margin-left: 20px;" type="primary" v-on:click="mySearch()">查询</Button>
					<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
				</FormItem>
			</Form>
		</Row>
		<Table border :columns="columns" :data="datas" style="padding-top: 20px;">
			<template slot-scope="{ row }" slot="loan_amount">
				<span>{{row.loan_amount}}万</span>
			</template>
			<template slot-scope="{ row }" slot="entrust">
				<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.content}}
					{{item.created_at}}
				</div>
				<div v-if="row.entrust.length == 0"></div>
			</template>
		</Table>
		<div class="pager1">
			<Page :total="count" show-total show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				@on-page-size-change="changeSize" :current="page" @on-change="changePage" size="small" show-elevator />
		</div>
	</div>
</template>

<script>
	import {
		getPushDataList,
		getSystemDataList
	} from "../../api/advManage";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		data() {
			return {
				columns: [{
						type: 'selection',
						width: 60,
						"align": "center"
					},
					{
						"title": "序号",
						type: "index",
						"align": "center",
						"width": 80
					},
					{
						"title": "姓名",
						"key": "name",
						"align": "center",
						"width": 80
					},
					{
						"title": "备注",
						"slot": "entrust",
						"align": "center",
						"width": 350
					},
					{
						"title": "星级",
						"key": "start_name",
						"align": "center",
						"width": 80
					},
					{
						"title": "状态",
						"align": "center",
						"key": "status_name",
						"width": 100
					},
					{
						"title": "发送状态",
						"align": "center",
						"key": "mask_send",
						"width": 100
					},
					{
						"title": "发送结果",
						"align": "center",
						"key": "mask_result",
						"width": 100
					},
					{
						"title": "贷款金额",
						"slot": "loan_amount",
						"align": "center",
						"width": 100,
					},
					{
						"title": "媒体代码",
						"key": "src",
						"align": "center",
						"width": 130
					},
					{
						"title": "媒体渠道",
						"key": "cidName",
						"align": "center",
						"width": 130
					},
					{
						"title": "城市",
						"key": "city",
						"align": "center",
						"width": 100,
					},
					{
						"title": "申请时间",
						"key": "time",
						"width": 150,
						"align": "center",
						"sortable": true
					},
					{
						"title": "分发公司",
						"align": "center",
						"key": "clientName",
						"width": 100
					},
					{
						"title": "分发时间",
						"key": "post_time",
						"width": 150,
						"align": "center",
						"sortable": true
					},
					{
						"title": "客户",
						"align": "center",
						"key": "old_src_id",
						"width": 100
					},
				],
				timePeriod: '5',
				timePeriodDate: [],
				postTimePeriod: '',
				postTimePeriodDate:'',
				datas: [],
				src:'',
				cid:'',
				clientId:'',
				cidList:[],
				clientList:[],
				srcList:[],
				city:'',
				name:'',
				cityList:[],
				distribute_status:'',
				count: 0,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
				};
				var data = {
					token: that.token,
				};
				var res = await getSystemDataList(that, data);
				if (res.code == 1) {
					that.cidList = res.data.cidList;
					that.clientList = res.data.clientList;
					that.cityList = res.data.cityList;
				}
			},
			initSearch() {
				this.name = '';
				this.cid = '';
				this.clientId = '';
				this.src = '';
				this.city = '';
				this.timePeriod = '5';
				this.timePeriodDate = [];
				this.postTimePeriod = '';
				this.postTimePeriodDate = [];
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			postTimePeriodDateChange(e) {
				this.postTimePeriodDate = e
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			initSearch() {
				this.city = '';
				this.statisticsWay = 1;
				this.clientId = '';
				this.src = '';
				this.timePeriod = '1';
				this.page = 1;
				this.timePeriodDate = [];
				this.followDepartment ='',
				this.getList();
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				data.order_type = that.order_type;
				let res = await getPushDataList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
				console.log(res.data)
			},
		},
	};
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #5555ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>